import { render, staticRenderFns } from "./DaftarJamKerja.vue?vue&type=template&id=2b3a27c2&scoped=true"
import script from "./DaftarJamKerja.vue?vue&type=script&lang=js"
export * from "./DaftarJamKerja.vue?vue&type=script&lang=js"
import style0 from "./DaftarJamKerja.vue?vue&type=style&index=0&id=2b3a27c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a27c2",
  null
  
)

export default component.exports